import React from 'react';
import MainBanner from '../HomeDefault/MainBanner';
import WhyUs from '../Common/WhyUs';
import GoTop from '../Shared/GoTop';
import Footer from '../Common/Footer';
import lax from 'lax.js';
import BuyTicket from '../Common/BuyTicket';
import Subscribe from '../Common/Subscribe';
import Partner from '../Common/Partner';
 
class HomeDefault extends React.Component {
    constructor(props) {
        super(props)
        lax.setup()
    
        document.addEventListener('scroll', function(x) {
            lax.update(window.scrollY)
        }, false)
    
        lax.update(window.scrollY)
    }

    render(){
        return (
            <React.Fragment>
                {/* Main Banner */}
                <MainBanner />
                {/* About Area */}
                <Partner />
                <WhyUs />
                <BuyTicket />
                {/* Subscribe Area */}
                <Subscribe />
                <Footer />
                {/* Back Top top */}
                <GoTop scrollStepInPx="50" delayInMs="16.66" />
            </React.Fragment>
        );
    }
}
 
export default HomeDefault;